import { useEffect, useState } from "react";

const QUERY = "(max-width: 767px)";

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState<boolean | undefined>();

  useEffect(() => {
    const mediaQuery = window.matchMedia(QUERY);
    const update = () => {
      setIsMobile(mediaQuery.matches);
    };
    update();
    mediaQuery.addEventListener("change", update);
    return () => {
      mediaQuery.removeEventListener("change", update);
    };
  }, []);

  return isMobile ?? false;
};
